import path from "path";
import JSZip from "jszip";
import func from "./func";
import {saveAs} from 'file-saver';

const dload = {
   download(name, files, progress) {
      return window.IS_ELECTRON
         ? dload.electron.download(name, files, progress)
         : dload.webZip.download(name, files, progress);
   },
   webZip: {
      async download(name, files, progress) {
         let zip = new JSZip();
         let num = files.length;
         while (files.length) {
            let promises = [];
            let max = Math.min(3, files.length)
            for (let i = 0; i < max; i++) {
               let file = files.pop();
               !file.url ? zip.file(file.name, file.text)
                  : promises.push(dload.webZip.saveUrl2Zip(zip, file.name, file.url));
            }
            await Promise.all(promises);
            progress(num - files.length, num, max);
         }
         await saveAs(await zip.generateAsync({type: "blob"}), `${name}.zip`);
      },
      async saveUrl2Zip(zip, name, url) {
         zip.file(name, await func.getData(url, "blob"));
      },
   },
   electron: {
      async download(name, files, progress) {
         let dir = await window.getDirectory();
         return this.download2(dir, files, progress);
      },
      async download2(dir, files, progress) {
         let num = files.length;
         if (!dir) return progress(num, num, 0);
         let upload = path.join(dir, "upload");
         while (files.length) {
            let promises = [];
            let max = Math.min(3, files.length)
            for (let i = 0; i < max; i++) {
               let file = files.pop();
               if (window.fsExistsSync(upload, file.name)) continue;
               !file.url ? window.saveText2File(dir, file.name, file.text)
                  : promises.push(window.saveUrl2File(dir, file.name, file.url));
            }
            await Promise.all(promises);
            progress(num - files.length, num, max);
         }
      },
   }
}

export default dload;
